import {Component, Input, OnInit, Output} from "@angular/core";
import {Option} from "../../classes/option";
import {StorageService} from "../../services/storage.service";

/**
 * Created by strunz on 12.05.2017.
 */


@Component({
    selector: 'inputField',
    templateUrl: './inputField.component.html',
    styleUrls: ['./inputField.component.css']
})
export class InputFieldComponent implements OnInit {
    @Input() option: Option;
    @Input() type = 'text';
    @Output() value = '';
    timer: any;

    constructor(private storageService: StorageService) {
    }

    ngOnInit(): void {
        for (const item of this.option.getAllItems()) {
            if (item.active) {
                this.value = item.id.toString();
                break;
            }
        }
    }

    update(): void {
        let intValue = parseInt(this.value, 10);
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            if (intValue < this.option.subItems[0].id) {
                intValue = this.option.subItems[0].id;
                this.value = intValue.toString();
            }
            for (const optionItem in this.option.subItems) {
                this.option.subItems[optionItem].active = false;
            }
            if (intValue > 0) {
                for (const item of this.option.subItems) {
                    if (item && item.id === intValue) {
                        item.active = true;
                    }
                }
                this.storageService.updateOptions();
            } else if (this.value === '') {
                this.storageService.updateOptions();
            }
        }, 1000);

    }
}
